import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { ErrorMessage } from '../'

export default ({ errors }) => {
  return (
    errors.length > 0 ? 
  <Row>
    <Col>
        {errors.map((error, i) => {
          return (
            <ErrorMessage key={i} error={error} />
        )})}
    </Col>
  </Row>
  : 
  <></>
)}